import { ApplicationSummary as BaseApplicationSummary } from "@certn/application/";
import { useTranslation } from "react-i18next";

export function ApplicationSummary() {
  const { t } = useTranslation();

  return (
    <BaseApplicationSummary
      alternativeHeaderText={t("Review & Submit")}
      alternativeDescriptionText={t(
        "Review the applicant's information and confirm that it is accurate. You can navigate back to any section to make edits before submitting."
      )}
      alternativeSubmitButtonText={t("Submit order")}
    />
  );
}
